module.exports = __webpack_public_path__ + "top_page/img-novelty-item@2x-ef41a3b041eb5ed3d3b0a8e336e358d0.png";